const StatusCircle = ({ variant }) => <div class={`status-circle ${variant ? `status-circle--${variant}` : 'status-circle--default'}`} />

export default StatusCircle
